import { MutationTree } from 'vuex';
import { initialState, MonCompteState } from './state';
import { MON_COMPTE } from '@/modules/MonCompte/store/mutation-types';

export const mutations: MutationTree<MonCompteState> = {
    [MON_COMPTE.SET_MODAL](state, isOpen: boolean) {
        state.isModaleOpen = isOpen;
    },
    [MON_COMPTE.RESET](state) {
        Object.assign(state, initialState);
    },
};
